const endpoints = {
  login: '/player/v2/auth/login',
  logout: 'auth/logout',
  loginPwdLess: '/auth/pwdless',
  forgotPwd: '/auth/reset/{0}',
  resetPwd: '/auth/chgpwdreset',
  refresh: 'auth/refresh',
  recipient1: 'newrecipient/recipient_form1',
  recipient2: 'newrecipient/recipient_form2',
  profile: 'profile',
  profileMerge: 'profile/merge',
  profileSplit: 'profile/split',
  release: 'release',
  genres: 'options/genres',
  markets: 'options/markets',
  options: 'options/',
  logos: 'options/logos',
  releaseDetail: 'release/{0}',
  releasePdf: 'release/{0}/report.{format}',
  audioToken: 'audio/{0}',
  audioStream: 'audio/stream/{0}.mp3',
  audioDownload: 'audio/download/{0}',
  videoDownload: 'video/download/{0}',
  audioZipper: 'audio/zipper/{0}',
  audioZipperStatus: 'audio/zipper/status/{0}',
  playlistZipper: 'playlist/zipper/{0}',
  playlistZipperStatus: 'audio/zipper/status/{0}',
  playList: 'playlist/',
  playListDetail: 'playlist/{0}',
  playListTracks: 'playlist/tracks/{0}',
  playlistPdf: 'playlist/{0}/report.pdf',
  playlistPin: 'playlist/pin/{0}',
  archive: 'archive',
  archiveDetail: 'archive/{0}',
  getTracks: 'playlist/tracks/{0}',
  deleteTrack: 'playlist/tracks/{0}/{1}',
  deleteAllTracks: 'playlist/tracks/{0}',
  flag: 'flag',
  flagDetail: 'flag/{0}',
  flagDetailTrack: 'flag/{0}/{1}',
  search: 'search',
  aiSearch: 'ai_search',
  urlConfig: 'https://sc.plaympe.com/paths.json',
  supportURL: 'https://www.plaympe.com/support/',
  aboutLink: 'https://www.plaympe.com',
  privacyPolicyLink: 'https://www.plaympe.com/privacy/',
  applyNow: 'https://www.plaympe.com/discover/get-started/',
  cancelSessions: '/auth/sessions',
  sendInvitations: '/accounts/player/invitations',
  registerDevice: 'notifications/device',
  commentRelease: '/release/{0}/comment',
  trackCommentingInit: '/release/{0}/comment_click',
  checkAccountsByEmail: '/accounts/player/signup/check-accounts-by-email',
  sendEmailVerificationCode:
    '/accounts/player/signup/send-email-verification-code',
  validateEmailVerificationCode:
    '/accounts/player/signup/validate-email-verification-code',
  confirmSignup: '/accounts/player/signup/confirm-signup',
  acceptInvitation: '/accounts/player/invitations/accept',
  connections: '/accounts/player/connections',
  deleteConnection: '/accounts/player/connections',
  processConnections: '/accounts/player/invitations/connect',
  shareRelease: '/accounts/player/connections/share-release'
}

export default { endpoints }
